import BaseWidget from "common/widgets/base/BaseWidget";
import locale from "common/managers/locale";
import classes from "app/css/widgets/DFDateTimePicker.module.less";

const DFDateTimePicker = BaseWidget(kendo.ui.DateTimePicker).extend({
    options: {
        name: "DFDateTimePicker",
        format: "g",
        parseFormats: locale.getDateTimeFormats()
    },

    init: function() {
        kendo.ui.DateTimePicker.fn.init.apply(this, arguments);
        this.element.attr("placeholder", locale.get("enter.datetime"));
        this.wrapper.addClass(classes.DFDateTimePicker);
        this.dateView.popup.element.addClass(classes.DFDateTimePickerDatePopup);
        this.timeView.popup.element.addClass(classes.DFDateTimePickerTimePopup);
    },


    /**
     * Patch date time picker to ensure that a value outside the valid range is never displayed.
     * @override
     * @private
     */
    _change: function(current) {
        var to = current;
        if (current) {
            var parsed = kendo.parseDate(current, this.options.parseFormats);
            if (parsed && this.options.min && parsed < this.options.min) {
                to = kendo.toString(this.options.min, this.options.format);
            } else if (parsed && this.options.max && parsed > this.options.max) {
                to = kendo.toString(this.options.max, this.options.format);
            }
        }
        return kendo.ui.DateTimePicker.fn._change.call(this, to);
    }
});
kendo.ui.plugin(DFDateTimePicker);
export default DFDateTimePicker;
